import { render, staticRenderFns } from "./newPlaning.vue?vue&type=template&id=4ca5fea8&scoped=true"
import script from "./newPlaning.vue?vue&type=script&lang=js"
export * from "./newPlaning.vue?vue&type=script&lang=js"
import style0 from "./newPlaning.vue?vue&type=style&index=0&id=4ca5fea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5fea8",
  null
  
)

export default component.exports